import { createSelector } from 'reselect';
import { getLang } from 'utils';
import { getPrice, getProductId, getProductImagesCount } from 'features/product-info';
import { getBreadcrumbs } from 'features/page-model';
import { computeFaqVariables } from '../utils/compute-faq-variables';

export const getFaqVariables = createSelector(
  getProductImagesCount,
  getBreadcrumbs,
  getProductId,
  getPrice,
  getLang,
  (imagesCount, breadcrumbs, productId, price, lang) =>
    computeFaqVariables({
      imagesCount,
      breadcrumbs,
      productId,
      price,
      lang,
    }),
);
